export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/store/modals/modal-publish-portals-error.store.ts"